import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import { g } from "xojs/lib/runtime/getGlobal";
export function isMobile() {
  return g.innerWidth && g.innerWidth < 768;
}
export function isRealMobile() {
  return g.innerWidth && g.innerWidth < 520;
}
export function slide(element, direction) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var height = element.scrollHeight;
  element.style.transition = "height ".concat(duration, "ms ease");
  element.style.overflow = 'hidden';
  switch (direction) {
    case 'up':
      element.style.height = "".concat(height, "px");
      requestAnimationFrame(function () {
        element.style.height = '0';
      });
      break;
    case 'down':
      element.style.display = 'block';
      element.style.height = '0';
      requestAnimationFrame(function () {
        element.style.height = "".concat(height, "px");
      });
      break;
    default:
      break;
  }
  _setTimeout(function () {
    if (direction === 'up') element.style.display = 'none';
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
}